import '@scss/shop/index.scss';
import './_icons';
import { fadeInBlock }  from '@ts/utils';
import { Modal } from '@ts/components/Modal';
import { Quantity } from '@ts/components/Quantity';
import { init as initCart } from './cart';
import { init as initCheckout } from './checkout';
import { init as initConfirmation } from './confirmation';
import { init as initMetrics } from './metrics';
import { init as initSupporters } from './supporters';
import { init as initVideo } from './video';
import { init as initListingFilters } from './listingFilters';
import { init as initNavigation } from './navigation';
import { init as initSearch } from './search';
import { init as initPDP } from './productDetail';
import { init as initEarlyAccess } from './earlyAccess';

document.addEventListener("DOMContentLoaded", () => {
       initCart();
       initCheckout();
       initConfirmation();
       initMetrics();
       initVideo();
       initListingFilters();
       fadeInBlock();
       initSupporters();
       initNavigation();
       initSearch();
       initPDP();
       initEarlyAccess();
       setInteractiveElements();
       setHTMXListeners();
});

const setModalTriggers = () => {    
    Modal.setModalTriggers(); 
}

const setQuantitySelector = () => {
    Quantity.create('.qty-field');
}

const setInteractiveElements = () => {
    setQuantitySelector();
    setModalTriggers();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', (evt) => { 
        setInteractiveElements(); 
    });
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}